// extracted by mini-css-extract-plugin
export var styledCard = "servicephoto-module--styledCard--21sIp";
export var styledText = "servicephoto-module--styledText--2igVP";